export const orderTypes = {
  1: '充值',
  2: '充电',
  3: '充值赠送',
  10: '充电退款',
  11: '充值退款',
  12: '月卡退款/套餐卡退款',
  13: '管理端赠送',
  20: '发起提现',
  21: '提现',
  22: '提现退回',
  24: '发起提现冻结赠送金额',
  25: '发起提现扣除赠送金额',
  26: '提现退回赠送金额',
  27: '超时占用',
  29: '超时占用退款',
}

export const orderStatus = {
  1: '等待开始',
  2: '进行中',
  3: '已完成',
  4: '异常停止',
  5: '人工关闭',
  6: '退单',
  7: '待支付',
  8: '已失效' // 单次充电支付订单，超过时长不支付过期状态
}

export const payTypes = {
  1: '钱包支付',
  2: '套餐支付',
  3: '微信支付'
}

// 套餐卡相关枚举

// 套餐类型
export const packageTypes = {
  1: '月卡',
  2: '季卡',
  3: '年卡',
}

// 套餐卡状态
export const packageCardStatus = {
  0: '下架',
  1: '上架',
}

// 套餐卡订单
export const packageCardOrderStatus = {
  0: '未支付',
  1: '已支付',
  2: '已退款',
  3: '已售后',
}
